<template>
    <div>
        <van-sticky>
            <van-dropdown-menu>
                <van-dropdown-item @change="changeDropdown" v-model="dropdownFilter.industry.value"
                                   :options="dropdownFilter.industry.option"/>
            </van-dropdown-menu>
        </van-sticky>
        <div class="echarts" ref="charts" style="height: 500px;margin-top: 16px"/>
    </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
    components: {},
    data() {
        return {
            dropdownFilter: {
                orderBy: {
                    value: 0,
                    option: [
                        {text: '默认排序', value: 0},
                        {text: '添加时间远到近', value: 1},
                        {text: '添加时间近到远', value: 2},
                        {text: '跟进时间远到近', value: 3},
                        {text: '跟进时间近到远', value: 4},
                    ],
                },
                industry: {
                    value: '0',
                    option: [
                        {text: '全部行业', value: '0'},
                    ],
                }
            },
            option: {
                title: {
                    text: '销售漏斗',
                    // subtext: '销售漏斗',
                    left: 'center',
                    top: 'top',
                },
                series: [
                    {
                        type: 'funnel',
                        left: '10%',
                        top: 40,
                        bottom: 0,
                        width: '80%',
                        min: 0,
                        max: 100,
                        // maxSize: '90%',
                        // minSize: '90%',
                        sort: 'none',
                        gap: 2,
                        // height: "350",
                        emphasis: {
                            label: {
                                fontSize: 14,
                            },
                        },

                        data: [
                            {
                                value: 100,
                                Status: 0,
                                name: '客户',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 80,
                                Status: 50,
                                name: '未知行业',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 70,
                                Status: 100,
                                name: '未跟进',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 60,
                                Status: 200,
                                name: '需求确认',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 50,
                                Status: 300,
                                name: '未演示、试用中',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 400,
                                name: '已演示、试用中',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 500,
                                name: '已演示、未试用',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 600,
                                name: '已成交',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                        ],
                    },
                ],
            },

        }
    },
    created() {
        this.getWXIndustry()
        this.get_data()
    },
    methods: {
        changeDropdown(value) {
            this.get_data()
        },
        async get_data() {
            this.ExternalUserFollowInfo = await this.$frame.getStdQueryData("ExternalUserFollowInfoAll", {
                IndustryNO: this.dropdownFilter.industry.value
            })
            this.group_data = this.$utils.groupBy(this.ExternalUserFollowInfo.StdQuery, ["Status"], (cur, data2) => {
                return cur + 1;
            })
            this.group_data_amount = this.$utils.groupBy(this.ExternalUserFollowInfo.StdQuery, ["Status"], (cur, data) => {
                return cur + data.ExpectAmount;
            })

            for (let i = 0; i < this.option.series[0].data.length; i++) {
                let _row = this.option.series[0].data[i]
                let _status = _row.Status.toString()
                this.option.series[0].data[i].label.formatter = _row.name +
                    "\r\n\r\n" + (this.group_data[_status] ? this.group_data[_status] : 0) + "人 , " +
                    (this.group_data_amount[_status] ? this.$utils.toMoney(this.group_data_amount[_status], 2) : 0) + "元"

                this.option.series[0].data[i].value = this.group_data[_status] / this.ExternalUserFollowInfo.StdQuery.length * 100

            }

            // this.option.series[0].data[0].label.formatter = "客户\r\n\r\n" + (this.group_data["0"] ? this.group_data["0"] : 0) + "人 , " + (this.group_data_amount["0"] ? this.$utils.toMoney(this.group_data_amount["0"], 2) : 0) + "元"
            // this.option.series[0].data[1].label.formatter = "需求确认\r\n\r\n" + (this.group_data["10"] ? this.group_data["10"] : 0) + "人 , " + (this.group_data_amount["10"] ? this.$utils.toMoney(this.group_data_amount["10"], 2) : 0) + "元"
            // this.option.series[0].data[2].label.formatter = "有意向\r\n\r\n" + (this.group_data["20"] ? this.group_data["20"] : 0) + "人 , " + (this.group_data_amount["20"] ? this.$utils.toMoney(this.group_data_amount["20"], 2) : 0) + "元"
            // this.option.series[0].data[3].label.formatter = "试用\r\n\r\n" + (this.group_data["30"] ? this.group_data["30"] : 0) + "人 , " + (this.group_data_amount["30"] ? this.$utils.toMoney(this.group_data_amount["30"], 2) : 0) + "元"
            // this.option.series[0].data[4].label.formatter = "已演示\r\n\r\n" + (this.group_data["40"] ? this.group_data["40"] : 0) + "人 , " + (this.group_data_amount["40"] ? this.$utils.toMoney(this.group_data_amount["40"], 2) : 0) + "元"
            // this.option.series[0].data[5].label.formatter = "已成交\r\n\r\n" + (this.group_data["50"] ? this.group_data["50"] : 0) + "人 , " + (this.group_data_amount["50"] ? this.$utils.toMoney(this.group_data_amount["50"], 2) : 0) + "元"
            //
            // this.option.series[0].data[0].value = this.group_data["0"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[1].value = this.group_data["10"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[2].value = this.group_data["20"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[3].value = this.group_data["30"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[4].value = this.group_data["40"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[5].value = this.group_data["50"] / this.ExternalUserFollowInfo.StdQuery.length * 100

            if (this.chart == null) {
                this.chart = echarts.init(this.$refs.charts, null, {
                    renderer: 'svg',
                })
                this.chart.on("click", this.clickChart)
            }
            this.chart.setOption(this.option)
        },
        async getWXIndustry() {
            let _data = await this.$frame.getStdQueryData("WXIndustry")
            this.dropdownFilter.industry.option = [{text: '全部行业', value: '0'},]
            for (let i = 0; i < _data.StdQuery.length; i++) {
                this.dropdownFilter.industry.option.push({
                    text: _data.StdQuery[i].IndustryDesc,
                    value: _data.StdQuery[i].IndustryNO
                })
            }
        },
        clickChart(params) {
            this.$router.push({
                path: "/manager/funnel_list",
                query: {
                    Status: params.data.Status
                }
            });
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
